let globalConfig = {
  // imgFormat: 'image/jpg,image/jpeg,image/png,image/bmp,image/tiff',
  imgFormat: '.jpg,.jpeg,.png',
  account_types:{
    1:'订阅号',
    2:'服务号'
  },
  KefuMsgType: {
    "text": "文本消息",
    "image": "图片消息",
    "voice": "语音消息",
    "video": "视频消息",
    "music": "音乐消息",
    "news": "文章链接",
    "mpnews": "公众号图文消息",
    "wxcard": "卡券消息",
    "miniprogrampage": "小程序消息",
    "msgmenu": "菜单消息"
  }
}

export default globalConfig;
